import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summaryData: null,
};

const testingAnalyticsSummarySlice = createSlice({
  name: "testingAnalyticsSummary",
  initialState,
  reducers: {
    fetchSummary: (state, action) => {
      state.loading = true;
      state.error = null;
      state.summaryData = null;
    },
    fetchSummarySuccess: (state, action) => {
      state.loading = false;
      state.summaryData = action.payload?.data || null;
    },
    fetchSummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions, reducer } = testingAnalyticsSummarySlice;
export const sliceKey = testingAnalyticsSummarySlice.name;